<template>
    <el-row :gutter="30">
        <el-col :lg="24" :xs="24">
            <el-card class="box-card">
                <template #header v-if="cachedUser.hasOwnProperty('avatar')">
                    <div class="card-header d-flex flex-column" >
                        <div class="d-flex align-start user-img">
                            <el-image style="width: 100px; height: 100px" :src="cachedUser.avatar" fit="cover" />
                            <font-awesome-icon :icon="['fas', 'pen-to-square']" class="cursor-pointer" @click="handleAvatarDialog" style="width:20px" />
                            
                        </div>
                        <span>{{cachedUser.fullName}}</span>
                    </div>
                    <div>
                        
                        
                    </div>
                </template>
                 <el-table :data="currentUser" style="width: 100%">
                    <el-table-column label="user Code" prop="userCode"/>
                    <el-table-column label="full name" prop="fullName"/>
                    <el-table-column label="email" prop="email"/>
                    <el-table-column label="phone" prop="phone"/>
                    <el-table-column label="user Type" prop="userType"/>
                    <el-table-column label="registration Date" prop="registrationDate"/>
                    
                    <el-table-column label="Operations">
                        <template #default="scope">
                            <el-button type="info" size="small" @click="handleEditProfile(scope.row)">Edit</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
        </el-col>
    </el-row>
    <el-dialog
        v-model="showAvatarDialog"
        title="Update Avatar"
        width="30%"
        :before-close="handleCloseAvatar"
    >
        <el-form class="text-center font-24" ref="uploadRef">
            <el-form-item >
                <el-upload
                    ref="upload"
                    action="#"
                    :auto-upload="false"
                    :on-change="onUpload"
                    :disabled="fileUploaded"
                    :on-remove="handleRemove"
                    class="font-24"
                >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text"> Drop file or click here</div>
                </el-upload>
                
            </el-form-item>
            
            <el-form-item v-if="fileUploaded">
                <el-button type="primary" @click="updateAvatar('uploadRef')" class="text-cap">send</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
    <el-dialog
        v-model="showProfileDialog"
        title="Update Profile"
        width="30%"
    >
        <el-form 
            class="text-center font-24" 
            ref="editProfile"
            :model="userToEdit"
            :rules="editProfileRules"
            label-position="top"
        >
            <el-row :gutter="30">
                <el-col :lg="24" :xs="24">
                    <el-form-item  label="first name" prop="firstName">
                        <el-input type="text" v-model="userToEdit.firstName"></el-input>    
                    </el-form-item>
                </el-col>
                <el-col :lg="24" :xs="24">
                    <el-form-item  label="last name" prop="lastName">
                        <el-input type="text" v-model="userToEdit.lastName"></el-input>    
                    </el-form-item>
                </el-col>
                <el-col :lg="24" :xs="24">
                    <el-form-item  label="phone" prop="phone">
                        <el-input type="text" v-model="userToEdit.phone"></el-input>    
                    </el-form-item>
                </el-col>
            </el-row>
            
            <el-form-item>
                <el-button type="primary" @click="updateProfile('editProfile')" class="text-cap">send</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>
<script>

export default {
    computed:{
        cachedUser(){
            return JSON.parse(localStorage.getItem('adminStore'))?.admin.user
        }
    },
    data(){
        return {
            currentUser:[],
            imageToSend:{},
            userToEdit:{},
            fileUploaded:false,
            showAvatarDialog:false,
            showProfileDialog:false,
            editProfileRules:{
                firstName:[
                    {
                        required:true,
                        trigger:'blur',
                        message:'field required',
                    }
                ],
                lastName:[
                    {
                        required:true,
                        trigger:'blur',
                        message:'field required',
                    }
                ],
                phone:[
                    {
                        required:true,
                        trigger:'blur',
                        message:'field required',
                    }
                ],
            }
        }
    },
    methods:{
        handleAvatarDialog(){
            this.showAvatarDialog = true
        },
        handleCloseAvatar(){
            this.showAvatarDialog = false
        },
        onUpload(file){
            this.imageToSend = file.raw;
            this.fileUploaded = true;
        },
        handleEditProfile(){
            this.showProfileDialog = true;
            this.userToEdit = JSON.parse(JSON.stringify(this.cachedUser))
        },
        handleRemove(){
            this.$refs.upload.clearFiles()
            this.fileUploaded = false;
        },
        async updateProfile(formName){
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    const response = await this.$store.dispatch('updateUserProfile',this.userToEdit)
                        if (response){
                            this.showProfileDialog = false;
                            location.reload()
                        }
                }else{
                    return
                }
            })
            
        },
        async updateAvatar(){
            const response = await this.$store.dispatch('updateUserAvatar',this.imageToSend)
            if (response){
                this.showAvatarDialog = false;
                location.reload()
            }
        },
    },
    mounted(){
        this.currentUser.push(this.cachedUser);
    }
}
</script>
<style lang="scss">
    @import '~@/assets/styles/variables';
    .user-img{
        .el-image {
            border: 2px dotted $brown;
            padding: 5px;
            margin-right: 10px;
        }
    }
</style>